import { Box, ButtonProps } from '@mui/material';
import { FC } from 'react';
import { ThreePointMenu, ThreePointMenuProps } from '../../../threePointMenu';
import { Button } from '../../../../atomic/button';

type Props = {
  buttonConfig?: {
    onClick: () => void;
    text: string;
    color: ButtonProps['color'];
  };
  operations?: JSX.Element;
  threePointMenuConfig?: ThreePointMenuProps<undefined>['config'];
};

export type ActionAreaProps = Props;

export const ActionArea: FC<Props> = ({ buttonConfig, operations, threePointMenuConfig }) => {
  return (
    <Box display={'flex'} gap={'32px'}>
      <Box flexShrink={0} display={'flex'} gap={'16px'}>
        {operations}
      </Box>
      {buttonConfig && (
        <Button onClick={buttonConfig.onClick} className={threePointMenuConfig && '-mr-4'}>
          {buttonConfig.text}
        </Button>
      )}
      {threePointMenuConfig && (
        <ThreePointMenu
          config={threePointMenuConfig}
          item={undefined}
          sx={{ marginTop: '12px', marginRight: '8px' }}
        />
      )}
    </Box>
  );
};
